module.exports = __webpack_public_path__ + "static/media/wagz_logo_blue.508832c2.svg";